import logo from './logo.svg';
import './App.css';
import {
  Routes,
  Route,
  BrowserRouter
} from 'react-router-dom';
import Home from './Home';
import Gallery from './Gallery';
// import Gas from './Gas';
// import Contactus from './Contactus';
// import Headers from './Headers';
// import About from './About';
// import Login from '../src/Auth/Login';
// import Register from '../src/Auth/Register';
// // import Dogbread from './Dogbread';
// import Dogbread from './dogbread/Dogbread';
// import Bread from './dogbread/Bread';
// import Identify from './dogbread/Identify.js';
// import Pricing from './dogbread/Pricing';
// import StripePayment from './StripePayment';
// import Profile from './dogbread/Profile';
// import Newhomes from './newhome/Newhomes';
// import Support from './newhome/Support';
// // import career from './newhome/Career';
// import Career from './newhome/Career';
// import Partner from './newhome/Partner';
// import Appointmentdoctors from './dogbread/Appointmentdoctors';
// import Newsfeed from './newsfeed/Newsfeed';
// import Bmidog from './Dogbmicalculator/Bmidog';
// import Forgotpass from '../src/Auth/Forgotpass';
// import Verifyotp from '../src/Auth/Verifyotp';
// import Resetpass from '../src/Auth/Resetpass';
// import Notfound from './notfound/Notfound';



function App() {
  return (
    <>
    {/* <Gas/> */}
{/* <Contactus/> */}
<BrowserRouter>
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/gallery" element={<Gallery />} />
      {/* <Route path="/Contact" element={<Contactus/>} />
      <Route path="/Headers" element={<Headers/>}/>
      <Route path="/about" element={<About/>}/>
      <Route path="/Login" element={<Login/>}/>
      <Route path="/Register" element={<Register/>}/>
      <Route path="/Dogbread" element={<Dogbread/>}/>
      <Route path="/bread" element={<Bread/>}/>
      <Route path="/identify-of-bread" element={<Identify/>}/>
      <Route path="/packages" element={<Pricing/>}/>
      <Route path="/profile" element={<Profile/>}/>
      <Route path="/" element={<Newhomes/>}/>
      <Route path="/support" element={<Support/>}/>
      <Route path="/career" element={<Career/>}/>
      <Route path="/partner" element={<Partner/>}/>
      <Route path="/Appointment" element={<Appointmentdoctors/>}/>
      <Route path="/Newsfeed" element={<Newsfeed/>}/>
      <Route path="/dog-bmi" element={<Bmidog/>}/>
      <Route path="/forgot" element={<Forgotpass/>}/>
      <Route path="/verifyotp" element={<Verifyotp/>}/>
      <Route path="/resetpass" element={<Resetpass/>}/>
      <Route path="*" element={<Notfound/>} /> */}


      
      






      </Routes>
      </BrowserRouter>
    
    
    </>
    
  );
}

export default App;
